module.exports = "<div> <div ng-if=vm.TreeListOptions kendo-tree-list=vm.TreeList k-options=vm.TreeListOptions></div> </div>";